module.exports = __webpack_public_path__ + "img/plan8.85f9cb73.svg";